var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3333 10C18.3333 9.53976 17.9602 9.16667 17.5 9.16667H7.5C7.03976 9.16667 6.66667 9.53976 6.66667 10C6.66667 10.4602 7.03976 10.8333 7.5 10.8333H17.5C17.9602 10.8333 18.3333 10.4602 18.3333 10Z",
    fill: "#4F5E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0893 10.5893C18.4147 10.2638 18.4147 9.73618 18.0893 9.41074L14.7559 6.07741C14.4305 5.75197 13.9028 5.75197 13.5774 6.07741C13.252 6.40285 13.252 6.93049 13.5774 7.25592L16.3215 10L13.5774 12.7441C13.252 13.0695 13.252 13.5972 13.5774 13.9226C13.9028 14.248 14.4305 14.248 14.7559 13.9226L18.0893 10.5893Z",
    fill: "#4F5E71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16667 16.6667C9.16667 16.2064 8.79357 15.8333 8.33333 15.8333H4.16667V4.16667H8.33333C8.79357 4.16667 9.16667 3.79357 9.16667 3.33333C9.16667 2.87309 8.79357 2.5 8.33333 2.5H4.16667C3.24619 2.5 2.5 3.24619 2.5 4.16667V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H8.33333C8.79357 17.5 9.16667 17.1269 9.16667 16.6667Z",
    fill: "#4F5E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbLogoutIcon);
export default __webpack_public_path__ + "static/media/ub-logoutIcon.f05db88ffdf1ced0fc390caff21e3d50.svg";
export { ForwardRef as ReactComponent };